module.exports = __webpack_public_path__ + "static/media/48397882_2309074662501045_6103162877101735936_o-thumb.060e2434.jpg";